export const EVENT_CATEGORY = {
  NAVIGATION: 'Navigation',
  ACTIVITY: 'Activity',
  PREFERENCE: 'Preference',
  NOTIFICATION: 'Notification',
  TOUR: 'Tour',
  HELP: 'Help',
  PERFORMANCE_TIMING: 'Performance Timing',
  UPGRADES: 'Upgrades',
  ONBOARDING: 'Onboarding'
}

const REACT_ACTION = 'React'

export const EVENT_ACTION = {
  SEARCH: 'Search',
  NQL: 'NQL',
  SPOTLIGHT_SEARCH_MODAL: 'Spotlight Search Modal',
  BULK_CHECKIN_MODAL: 'Bulk Checkin Modal',
  GOAL_CONTRIBUTIONS_MODAL: 'Goal Contributions modal',
  SET_GOAL_CONTRIBUTIONS: 'Set Goal Contributions',
  SAVE_GOAL_CONTRIBUTIONS: 'Save Goal Contributions',
  BULK_CHECKIN: 'Bulk Checkin',
  CHECK_IN: 'Checkin',
  ACTIVITY_MODAL: 'Activity Modal',
  ACTIVITY_MODAL_KB: 'Activity Modal KB',
  REQUEST_UPDATE_ICON: 'Request for update - Icon',
  REQUEST_UPDATE_MENU: 'Request for update - Menu',
  SHOW_CHILD_GOALS: 'Show child goals',
  HIDE_CHILD_GOALS: 'Hide child goals',
  SHOW_KR_DETAIL: 'Show KR detail',
  HIDE_KR_DETAIL: 'Hide KR detail',
  REARRANGE: 'Re-arrange',
  OPEN_PAGE: 'Open Page',
  BACK_BUTTON: 'Back button',
  FILTER_TIMELINE: 'Filter Timeline',
  FILTER_TEAM: 'Filter Team',
  RESET_FILTER: 'Reset Filter',
  OPEN_TEAM_ACTIVITY_VIEW: 'Open Team Activity View',
  OPEN_TEAM_BOARD_VIEW: 'Open Team Board View',
  OPEN_ORG_BOARD_VIEW: 'Open Org Board View',
  OPEN_ORG_ACTIVITY_VIEW: 'Open Org Activity View',
  APPLY_FILTER: 'Apply Filter',
  APPLY_GROUPING: 'Apply Grouping',
  CHANGE_INITIATIVE_VIEW: 'Change Initiative View',
  RESET_FILTERS: 'Reset Filters',
  CLICK_CHECKIN_REMINDER: 'Click Check-in-reminder',
  SEE_CHECKIN: 'See Checkin',
  SORT_INITIATIVES: 'Sort - Initiatives',
  SORT_IDEAS: 'Sort - Ideas',
  FILTER_INITIATIVES: 'Filter - Initiatives',
  FILTER_IDEAS: 'Filter - Ideas',
  CHANGE_ALIGNMENT: 'Change Alignment',
  EDIT_GOAL: 'Edit Goal',
  ADD_KR: 'Add KR',
  DOCK: 'Dock',
  DOCK_FAN: 'Dock Fan',
  DOCK_CLICK: 'Dock Click',
  COMPLETE: 'Complete',
  SKIP: 'Skip',
  NEW_COMMENT: 'New Comment',
  CHECKIN_TEMPLATE_SEEN: 'Check-in Template Seen',
  VISION_TEMPLATE_SEEN: 'Vision Template Seen',
  OPEN_CHECK_IN_MODAL: 'Open Check-in Modal',
  ACTIVITY_FILTER_YOUR_WORK: 'Activity Filter - Your Work',
  ACTIVITY_FILTER_REPORT: 'Activity Filter - Report',
  API_RESOURCE_LOAD: 'API Resource Load',
  REACT: REACT_ACTION,
  UNREACT: 'Unreact',
  PEEK_SIDEBAR: 'Peek Sidebar',
  HIDE_SIDEBAR: 'Hide Sidebar',
  PIN_SIDEBAR: 'Pin Sidebar',
  SET_INITIATIVE_DUE_DATE: 'Set Due-date - Initiative',
  SET_INITIATIVE_STATUS: 'Set Status - Initiative',
  SET_INITIATIVE_PRIORITY: 'Set Priority - Initiative',
  ADD_INITIATIVE: 'Add Initiative',
  ADD_TASK: 'Add Task',
  NEXT_PREVIOUS_INITIATIVE: 'Move <> Initiative Modal',
  EDIT_NOTE: 'Edit Note',
  CLICK_RECENT: 'Click Recent',
  VISIT_NORTH_UNI: 'Visit North Uni',
  PLANS_PAGE_SEEN: 'Plans page seen',
  UPGRADE_BUTTON_CLICKED: 'Upgrade Button clicked',
  UPGRADE_SUCCESSFUL: 'Upgrade Successful',
  UPGRADE_FAILED: 'Upgrade Failed',
  PAYWALL_CLICKED: 'Paywall clicked',
  CREATE_ACCOUNT_STARTED: 'Account creation started',
  ACCOUNT_VERIFICATION_STARTED: 'Account verification started',
  ACCOUNT_VERIFIED: 'Account verified',
  ACCOUNT_VERIFICATION_FAILED: 'Account verification failed',
  SET_PASSWORD: 'Set password',
  ACCOUNT_INFO_SUBMITTED: 'Account info submitted',
  ORG_CREATED: 'Org Created',
  INVITES_SKIPPED: 'Invites skipped',
  INVITES_SENT: 'Invites sent',
  INVITE_ACCEPTED: 'Invite accepted',
  ORG_JOINED: 'Org joined',
  INVITE_VERIFICATION_FAILED: 'Invite verification failed',
  INVITE_ACCEPTANCE_FAILED: 'Invite acceptance failed',
  ONBOARDING_TOUR_STEP_SEEN: 'Onboarding tour step seen',
  ONBOARDING_COMPLETED: 'Onboarding completed',
  SEARCH_NORTH_AI: 'Search North AI',
  DEMO_ORG_CREATED: 'Demo org created',
  NEW_GOAL_AI_CLICKED: 'New goal-ai clicked',
  NEW_GOAL_CREATED: 'New Goal created',
  NEW_GOAL_CLICKED: 'New goal clicked',
  IN_APP_TOUR_STARTED: 'In-app tour started',
  IN_APP_TOUR_SKIPPED: 'In-app tour skipped',
  IN_APP_TOUR_COMPLETED: 'In-app tour completed'
}

export const CUSTOM_EVENT_ACTION = {
  react: REACT_ACTION
}

export const EVENT_NAME = {
  KR: 'KR',
  INITIATIVE: 'Initiative',
  TASK: 'Task',
  GOAL: 'Goal',
  CHILD_GOAL: 'Goal',
  ALL_INITIATIVES: 'All Initiatives',
  ALL_ACTIVITY: 'All Activity',
  SPOTLIGHT: 'Spotlight',
  KR_ACTIVITY_MODAL: 'KR Activity Modal',
  BOARD_VIEW: 'Board View',
  SNOOZE: 'Snooze',
  BULK_CHECK_IN: 'Bulk Checkin',
  STATUS: 'Status',
  TITLE: 'Title',
  DUE: 'Due',
  PRIORITY: 'Priority',
  IMPACT: 'Impact',
  OWNER: 'Owner',
  REACH: 'Reach',
  EFFORT: 'Effort',
  GOAL_MENU: 'Goal Menu',
  GOAL_PAGE: 'Goal Page',
  USER_PAGE: 'User Page',
  KR_PAGE: 'KR Page',
  INLINE_LINK: 'Inline-link',
  APP_TOUR: 'App Tour',
  CREATE_GOAL: 'Create Goal',
  CREATE_INITIATIVE: 'Create Initiative',
  GIVE_AWARD: 'Give Award',
  GOAL_AWARD: 'Goal Award',
  KR_AWARD: 'KR Award',
  INITIATIVE_AWARD: 'Initiative Award',
  IDEA_LIST: 'Idea List',
  IDEA_LISTS: 'Idea Lists',
  IDEA: 'Idea',
  LIST_VIEW: 'List View',
  TOP: 'Top',
  INITIATIVE_COMMENT: 'Initiative Comment',
  CHECKIN: 'Checkin',
  GOAL_CLOSED: 'Goal Closed',
  GOAL_REOPENED: 'Goal Re-opened',
  KR_CLOSED: 'Goal Closed',
  KR_REOPENED: 'Goal Re-opened',
  INITIATIVE_CLOSED: 'Initiative Closed',
  INITIATIVE_REOPENED: 'Initiative Re-opened',
  INITIATIVE_FIELD_CHANGED: 'Initiative field changed',
  GOAL_COMMENT: 'Goal Comment',
  KR_COMMENT: 'KR Comment',
  RECENT: 'Recent',
  GOAL_AND_KR: 'Goals and KRs',
  INITIATIVES_TASKS: 'Initiatives and Tasks',
  COMMENTS: 'Comments',
  ALL: 'All',
  INLINE_ICON: 'Inline Icon',
  INITIATIVE_MENU: 'Initiative Menu',
  SECTION: 'Section'
}

export const SOURCE = {
  TEAM_PAGE: 'Team page',
  GOAL_PAGE: 'Goal page',
  KR_PAGE: 'KR page',
  KR_PAGE_BUTTON: 'KR page button',
  KR_PAGE_WIDGET: 'KR page widget',
  ALL_GOALS_PAGE: 'All goals page',
  ALL_KRS_PAGE: 'All krs page',
  CHECKIN_REMINDER_BAR: 'Checkin reminder bar',
  YOUR_WORK: 'Your work page',
  YOUR_GOALS_SECTION: 'Your goals section',
  CHILD_GOALS_SECTION: 'Child goals section',
  ARCHIVES_PAGE: 'Archives page',
  INBOX: 'Inbox',
  SIDEBAR_MENU: 'Sidebar menu',
  GOAL_MENU: 'Goal Menu',
  KR_DETAILS_POPOVER: 'KR details popover',
  REVIEW_CONTRIBUTIONS_POPOVER: 'Review Contributions popover'
}

export const CHECKIN_TYPE = {
  SINGLE: 'Single',
  BULK: 'Bulk'
}
export const ACTOR_TYPE = {
  GOAL_OWNER: 'Goal owner',
  KR_OWNER: 'KR owner',
  NON_OWNER: 'Non-owner'
}

export const CHECKIN_DUE = {
  CHECK_IN_DUE: 'Check-in due',
  CHECK_IN_OVERDUE: 'Check-in overdue'
}

export const DATA_SOURCE = {
  MANUAL: 'Manual',
  GOOGLE_SHEET: 'Google sheet'
}

export const ONBOARDING_FLOW_TYPE = {
  SIGNUP: 'signup',
  INVITE: 'invite',
  SIGN_IN: 'sign_in'
}

export const ONBOARDING_ACCOUNT_TYPE = {
  EMAIL: 'email',
  GOOGLE: 'google',
  MICROSOFT: 'microsoft'
}
